<template>
  <!-- <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </nav> -->
   <keep-alive>

  <router-view/>
   </keep-alive>
  <Canvas/> 
</template>

<script>
import Canvas from '@/components/canvas.vue'  
export default {
  
  components: {
    Canvas 
  },
  mounted(){ 
      
  },
   data() {
          return { 
            loading:false,
            error:null,
        };
   },
  methods:{
    
    // loadBasics(){
    //  var $main_nav = $('#main-nav');
    // var $toggle = $('.toggle');
    // var defaultOptions = {
    //     disableAt: false,
    //     customToggle: $toggle,
    //     levelSpacing: 40,
    //     navTitle: 'App',
    //     levelTitles: true,
    //     levelTitleAsBack: true,
    //     pushContent: '#container',
    //     insertClose: 2
    // };
    // var Nav = $main_nav.hcOffcanvasNav(defaultOptions);
    // }
  }
}
</script>
<style>
.bg-primary,.footer{
    background-color: #006c6f !important;
  /*background: linear-gradient(328deg, #ff0000, #000199);*/
}
.footer a{
  color: white !important;
    font-weight: 600;
}
</style>
